import StyleGrid from "./layout/style-grid";
import StyleList from "./layout/style-list";

function RenderView(props) {
	const { style, data } = props;

	return (
		<>
			{style === 'grid' && <StyleGrid {...props} data={data} />}
			{style === 'list' && <StyleList {...props} data={data} />}
		</>
	)
}

export default RenderView;